import React, { useState, useEffect, useRef } from 'react';
import { FileUploader, Loader } from 'quantux-ui';
import { css, StyleSheet } from 'aphrodite/no-important';
import { equal, padZero } from '../../utils';
import { blue, gray } from '../../theme';

const ThumbnailsPanel = (props) => {
  const [pages, setPages] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  // --- Props -----------------------------------------------------------------
  const { showLoader } = props;

  // --- Refs -----------------------------------------------------------------
  const documentRef = useRef();

  // --- Effect ---------------------------------------------------------------
  useEffect(() => {
    if (!equal(pages, props.caseDocs)) {
      setPages(props.caseDocs);
    }
  }, [props.caseDocs]);

  // Document upload effect (show loader - when document upload is in progress)
  useEffect(() => {
    setIsUploading(showLoader);
  }, [showLoader]);

  useEffect(() => {
    if (props.activeDocId !== selectedDocument) {
      setSelectedDocument(props.activeDocId);
    }
  }, [props.activeDocId]);

  // --- Styles ---------------------------------------------------------------
  const styles = StyleSheet.create({
    thumbnailsPanel: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      position: 'absolute',
      width: '124px',
      overflowY: 'auto',
      background: blue[900],
      borderRight: `1px solid ${blue[600]}`,
      zIndex: '2500',
      top: `${props.top}px`,
      left: '0',
      height: `calc(100% - ${props.top}px)`
    },
    thumbnailContainer: {
      background: blue[900],
      width: '100px'
    },
    thumbnail: {
      minHeight: '118px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    thumbnailImage: {
      maxHeight: '108px',
      maxWidth: '84px'
    },
    thumbnailPageNumber: {
      background: blue[900],
      height: '20px',
      textAlign: 'center',
      lineHeight: '14px',
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold',
      paddingTop: '2px',
      paddingLeft: '4px'
    }
  });

  // --- Event Handlers -------------------------------------------------------
  const handleOnDocumentDrop = () => {};

  const handleOnDocumentFileSelected = () => {};

  return (
    <div className={css(styles.thumbnailsPanel)}>
      {/* Thumbnails */}
      {pages.map((page, idx) => {
        return (
          <div
            key={page.id}
            className={`mt-2 ${css(styles.thumbnailContainer)}`}
            style={{
              border: selectedDocument === page.id
                ? `4px solid ${blue[400]}`
                : `2px solid ${gray[300]}`
            }}
          >
            {/* Thumbnail */}
            <div className={css(styles.thumbnail)}>
              <img
                onClick={() => {
                  const tmpIndex = pages.findIndex(el => el.id === page.id);
                  props.onThumbnailSelected(pages[tmpIndex].id);
                }}
                // src={page.imageUrl}
                src={page.compositeImage}
                className={css(styles.thumbnailImage)}
              />
            </div>
            {/* Page number */}
            <div
              className={css(styles.thumbnailPageNumber)}
              style={{
                color: selectedDocument === page.id ? blue[400] : ''
              }}
            >
              {`Page ${padZero(idx + 1)}`}
            </div>
          </div>
        );
      })}
      {/* Loader */}
      {isUploading &&
        <Loader
          iconType="cog"
          iconSize="2x"
          text={'Uploading...'}
        />
      }
      {/* File Uploader */}
      {props.canUploadFiles &&
        <div
          style={{
            flexGrow: '1',
            marginTop: '8px',
            width: '100%',
            minHeight: '146px',
            display: isUploading ? 'none' : ''
          }}
        >
          <FileUploader
            title='Drop'
            showOrLineBreak={false}
            text=''
            style={{ height: '100%', width: '100%', backgroudColor: blue[900] }}
            parentRef={documentRef}
            onDrop={props.onDocumentDrop}
            onChange={handleOnDocumentFileSelected}
          />
        </div>
      }
    </div>
  );
};

ThumbnailsPanel.defaultProps = {
  canUploadFiles: true,
  top: 40
};
export default ThumbnailsPanel;
